import { languageMap } from ".."

languageMap.autoit = {
	comments: {
		line: ";",
		block: ["#cs", "#ce"],
	},
}
